import { Container } from '@paypalcorp/pp-react'
import React, { createRef, useState, useEffect } from 'react'
import { config } from './config'
import { DropdownListItemLink } from '../DropdownListItemLink'
import './navigation-buttons.css'
import { traverseListWithKeyboard } from '../utils/keyboardNavigation'

interface NavigationButtonProps {
  navList: any
}

const NavigationButton: React.FC<NavigationButtonProps> = ({ navList }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [cursor, setCursor] = useState<any>(null)

  useEffect(() => {
    if (!isOpen) {
      setCursor(null)
    }
  }, [isOpen])

  return (
    <li
      className={`nav-item ${isOpen && 'nav-item__selected'}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onFocus={() => setIsOpen(true)}
      onBlur={() => setIsOpen(false)}
      onKeyDown={(e) => traverseListWithKeyboard(e, navList, setCursor)}
    >
      <div>
        <a
          className={`menu-link ${isOpen && 'menu-link__selected'}`}
          href={navList.link}
          tabIndex={0}
        >
          {navList.title}
        </a>
        <div
          className={`${isOpen && `dropdown-content__open`} dropdown-content`}
        >
          {navList.children &&
            navList.children.map((item: any, i: any) => (
              <DropdownListItemLink
                item={item}
                active={i === cursor}
                parent="navigationButton"
                key={i}
              />
            ))}
        </div>
      </div>
    </li>
  )
}

const NavigationButtons = () => {
  return (
    <Container className="nav-container">
      <ul className="header-list">
        {config.map((navList) => (
          <NavigationButton navList={navList} key={navList.id} />
        ))}
      </ul>
    </Container>
  )
}

export default NavigationButtons
